//@ts-nocheck
import { Box } from '@jfs/ui-new'
import { memo, useEffect, useState } from 'react';
import { Dimensions } from 'react-native'
import { DataProvider, LayoutProvider, RecyclerListView } from 'recyclerlistview'
interface CustomSectionListProps {
  onEndReached: any
  renderOperatorItem: any
  data: any[]
}

const InstituteListSectionListtsx = memo(({ renderOperatorItem, data, onEndReached }: CustomSectionListProps) => {
  const [_dataProvider, setDataProvider] = useState(
    new DataProvider((r1, r2) => {
      return r1 !== r2
    }).cloneWithRows(data),
  )

  useEffect(() => {
    setDataProvider((dataProvider) => dataProvider.cloneWithRows(data))
  }, [data])

  const _renderRecycleView = (_type: any, item: any, index: any) => {
    return renderOperatorItem({ item, index })
  }

  const [_layoutProvider, setLayoutProvider] = useState(null)

  useEffect(() => {
    setLayoutProvider(
      new LayoutProvider(
        (index) => {
          return 'OPERATORITEM'
        },
        (type, dim) => {
          dim.width = Math.round(Dimensions.get('window').width)
          dim.height = 54
        },
      ),
    )
  }, [data])

  return (
    <Box flex={1} testID="instituteList" alignSelf="stretch">
      {data && data.length > 0 && (
        <RecyclerListView
          style={{ flex: 1 }}
          dataProvider={_dataProvider}
          rowRenderer={_renderRecycleView}
          layoutProvider={_layoutProvider}
          canChangeSize={false}
          renderAheadOffset={400}
          onEndReached={onEndReached}
          onEndReachedThreshold={50}
        />
      )}
    </Box>
  )
})

export { InstituteListSectionListtsx }
